import React from 'react';
import PropTypes from 'prop-types';
import PendingPayoutsRow from './PendingPayoutsRow';
import PendingPayoutItems from './PendingPayoutItems';
import CollapseElement from '../../elements-collapse/Collapse';
import Table from '../../elements-table/table';
import Button from '../../elements-buttons/Button';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from '../../shared-components/hocs/sharedIntlProviderHOC';

const PendingPayoutsTable = ({
  payouts,
  total,
  dispatch,
  fetchPendingPayouts,
  maxCount = 5
}) => (
  <div className="PendingPayoutsTable">
    <h4>{`Pending (${total})`}</h4>
    <p>
      <FormattedMessage
        id="hosting.pending_payouts_table.pending_payout_text"
        defaultMessage="Pending payouts have not been completed."
      />&nbsp;
      <a href={`https://support.peerspace.com/hc/${SharedIntlProviderHOC.getZendeskLocale()}/articles/360033742151`}>
        <FormattedMessage
          id="hosting.pending_payouts_table.pending_payout_link_text"
          defaultMessage="Learn more about pending statuses."
        /></a></p>
    <Table
      headerContainerClass="payouts-table-header"
      tableHeaders={
        [
          { label: <FormattedMessage id="hosting.pending_payouts_table.headers_last_updated" defaultMessage="Last Updated" /> , classname: 'flex-basis-15  hidden-xs' },
          { label: <FormattedMessage id="hosting.pending_payouts_table.headers_status" defaultMessage="Status" />, classname: 'flex-basis-15 flex-basis-25-sm flex-basis-45-xxs status-header' },
          { label: <FormattedMessage id="hosting.pending_payouts_table.headers_description" defaultMessage="Description" />, classname: 'flex-basis-35 hidden-xxs' },
          { label: <FormattedMessage id="hosting.pending_payouts_table.headers_booking_end_date" defaultMessage="Booking End Date" />, classname: 'flex-basis-15 text-right visible-lg' },
          { label: <FormattedMessage id="hosting.pending_payouts_table.headers_amount" defaultMessage="Amount" />, classname: 'flex-basis-15 flex-basis-20-sm flex-basis-45-xxs text-right' },
          { label: '', classname: 'flex-basis-5 flex-basis-10-xxs' }
        ]
      }
      tableBodyClass="payouts-table-body no-gutter"
      tableBody={
        payouts.map((payout) => {
          return (
            <CollapseElement
              key={payout._id}
              buttonClassname="payouts-row btn-reset"
              buttonText={
                <PendingPayoutsRow payout={payout} />
              }
            >
              <div>
                <PendingPayoutItems payout={payout} />
              </div>
            </CollapseElement>
          );
        })
      }
    />
    {
      maxCount < total &&
      <div className="text-center margin-lg-top">
        <Button
          buttonClassname="text-center"
          category="default"
          onClick={() => dispatch(fetchPendingPayouts(`&count=${maxCount < payouts.length ? maxCount : 'all'}`))}
          attributes={{ 'data-testing-id': 'toggle-pending-show' }}
          isLoading={false}
          className="btn-outlined-light"
        >
          { maxCount < payouts.length ?
            <FormattedMessage
              id="hosting.pending_payouts_table.button_text_show_less"
              defaultMessage="Show less"
            /> :
            <FormattedMessage
              id="hosting.pending_payouts_table.button_text_show_all"
              defaultMessage="Show all"
            /> }
        </Button>
      </div>
    }
  </div>
);

PendingPayoutsTable.propTypes = {
  payouts: PropTypes.array.isRequired,
  maxCount: PropTypes.number,
  fetchPendingPayouts: PropTypes.func,
  dispatch: PropTypes.func,
  total: PropTypes.number
};

export default PendingPayoutsTable;
